"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const languageSelectStyles = _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles, {
  container: provided => _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles.container(provided), {
    'margin-top': '2px'
  }),
  control: provided => _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles.control(provided), {
    border: _netlifyCmsUiDefault.borders.textField,
    padding: 0,
    fontSize: '13px',
    minHeight: 'auto'
  }),
  dropdownIndicator: provided => _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles.dropdownIndicator(provided), {
    padding: '4px'
  }),
  option: (provided, state) => _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles.option(provided, state), {
    padding: 0,
    paddingLeft: '8px'
  }),
  menu: provided => _objectSpread({}, _netlifyCmsUiDefault.reactSelectStyles.menu(provided), {
    margin: '2px 0'
  }),
  menuList: provided => _objectSpread({}, provided, {
    'max-height': '200px'
  })
});

var _default = languageSelectStyles;
exports.default = _default;